import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { AUTH_INITIAL_STATE } from '../../constants';
import './Logout.css';
import i18n from '../../i18n';

export const Logout = ({ lang }) => {
    const { setState } = useAuth();
    const getCopy = (i18nKey) => i18n.getCopy(lang, i18nKey);
    return (
        <button
            className="LogoutButton"
            onClick={() => {
                setState(AUTH_INITIAL_STATE);
            }}
        >
            {getCopy('support.form.logout.button')}
        </button>
    );
};



// WEBPACK FOOTER //
// ./src/components/Logout/Logout.js